class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    if (facetForm) {
      facetForm.addEventListener('input', (event) => {
        FacetFiltersForm.syncMirroredInputs(event.target);
        this.debouncedOnSubmit(event);
      });
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    //const facetTiggers = this.querySelectorAll('.facets__button-show,.facets__container__overlay');
    //if (facetTiggers.length > 0) {
		//	facetTiggers.forEach(trigger => {
		//		trigger.addEventListener('click',()=> {
		//			this.querySelector('.facets__container').classList.toggle('active');
		//			this.querySelector('.facets__container__overlay').classList.toggle('active');
		//			document.body.classList.toggle('overflow-hidden');
		//		});
		//	})
    //}
		this.bindFacetTriggers();

    if (!FacetFiltersForm.outsideClickBound) {
      document.addEventListener('click', (event) => {
        const detailsList = document.querySelectorAll('.facets__wrapper--horizontal:not(.facets__wrapper--horizontal_united) .facets__disclosure');
        const details = event.target.closest('.facets__disclosure[open]');

        if (!details && detailsList.length) {
          detailsList.forEach((item) => {
            item.removeAttribute('open');
          });
        }
      });
      FacetFiltersForm.outsideClickBound = true;
    }
  }

	bindFacetTriggers() {
    const facetTriggers = this.querySelectorAll('.facets__button-show, .facets__container__overlay, .close-drawer');
    if (facetTriggers.length > 0) {
      facetTriggers.forEach((trigger) => {
        if (trigger.dataset.facetsBound === 'true') return;
        trigger.dataset.facetsBound = 'true';

        trigger.addEventListener('click', () => {
          const container = this.querySelector('.facets__container');
          const overlay = this.querySelector('.facets__container__overlay');
          if (!container || !overlay) return;

          container.classList.toggle('active');
          overlay.classList.toggle('active');
          document.body.classList.toggle('overflow-hidden');
        });
      });
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static syncMirroredInputs(origin) {
    if (!origin || origin.type !== 'checkbox') return;

    const mirrorKey = origin.dataset.filterMirrorKey;
    if (!mirrorKey) return;

    document.querySelectorAll('[data-filter-mirror-key]').forEach((input) => {
      if (input === origin || input.dataset.filterMirrorKey !== mirrorKey || input.disabled) return;
      input.checked = origin.checked;
    });
  }

  static snapshotDrawerState(origin = null) {
    FacetFiltersForm.drawerOpen = isFilterDrawerOpen();
    FacetFiltersForm.openGroupKeys = getOpenFilterDrawerGroupKeys();
    FacetFiltersForm.lastMirrorKey = origin && origin.dataset ? origin.dataset.filterMirrorKey || null : null;
  }

  static restoreFilterDrawerState() {
    const drawer = getFilterDrawerElement();
    if (!drawer) {
      document.body.classList.remove('filter-drawer-open');
      FacetFiltersForm.drawerOpen = false;
      FacetFiltersForm.openGroupKeys = null;
      return;
    }

    const savedKeys = Array.isArray(FacetFiltersForm.openGroupKeys) ? [...FacetFiltersForm.openGroupKeys] : null;
    const groups = Array.from(drawer.querySelectorAll('[data-filter-group-key]'));

    if (savedKeys !== null) {
      if (savedKeys.length === 0) {
        groups.forEach((group) => {
          group.open = false;
        });
      } else {
        const matchingGroups = groups.filter((group) => savedKeys.includes(group.dataset.filterGroupKey));
        if (matchingGroups.length > 0) {
          groups.forEach((group) => {
            group.open = savedKeys.includes(group.dataset.filterGroupKey);
          });
        }
      }
    }

    if (FacetFiltersForm.drawerOpen) {
      setFilterDrawerOpen(true);

      const preferredInput = Array.from(drawer.querySelectorAll('[data-filter-popup-checkbox]')).find((input) => {
        return input.dataset.filterMirrorKey === FacetFiltersForm.lastMirrorKey;
      });

      if (preferredInput) preferredInput.focus();
    } else {
      setFilterDrawerOpen(false);
    }
  }

  static isHorizontalDesktopMode(parsedHTML) {
    const form = parsedHTML.getElementById('FacetFiltersForm');
    return Boolean(form && form.classList.contains('facets__form--horizontal_united'));
  }

  static renderHorizontalFilters(parsedHTML) {
    const sourceWrapper = parsedHTML.getElementById('FacetsWrapperDesktop');
    const targetWrapper = document.getElementById('FacetsWrapperDesktop');
    if (!sourceWrapper || !targetWrapper) return;

    targetWrapper.innerHTML = sourceWrapper.innerHTML;
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const productGridContainer = document.getElementById('ProductGridContainer');
    const collection = productGridContainer ? productGridContainer.querySelector('.collection') : null;
    if (collection) collection.classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

		const facetFiltersForm = document.querySelector('facet-filters-form');
    if (facetFiltersForm) facetFiltersForm.bindFacetTriggers();

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const targetContainer = document.getElementById('ProductGridContainer');
    const sourceContainer = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
    if (!targetContainer || !sourceContainer) return;

    targetContainer.innerHTML = sourceContainer.innerHTML;
    if (document.querySelector('.js-load-more') || document.querySelector('.js-infinite-scroll')) 
      loadMore();
    
    colorSwatches();
  }

  static renderProductCount(html) {
    const sourceCount = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (!sourceCount || !container) return;

    const count = sourceCount.innerHTML
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    if (FacetFiltersForm.isHorizontalDesktopMode(parsedHTML)) {
      FacetFiltersForm.renderHorizontalFilters(parsedHTML);
      FacetFiltersForm.renderActiveFacets(parsedHTML);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);
      FacetFiltersForm.restoreFilterDrawerState();
      const facetFiltersForm = document.querySelector('facet-filters-form');
      if (facetFiltersForm) facetFiltersForm.bindFacetTriggers();
      return;
    }

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const targetElement = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (targetElement) targetElement.innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    FacetFiltersForm.restoreFilterDrawerState();
		const facetFiltersForm = document.querySelector('facet-filters-form');
    if (facetFiltersForm) facetFiltersForm.bindFacetTriggers();
    if (countsToRender && event && event.target) {
      const targetFilter = event.target.closest('.js-filter');
      if (targetFilter) FacetFiltersForm.renderCounts(countsToRender, targetFilter);
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const targetElement = document.querySelector(selector);
      if (!activeFacetsElement || !targetElement) return;
      targetElement.innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting','.facets__selected'];

    mobileElementSelectors.forEach((selector) => {
      const sourceElement = html.querySelector(selector);
      const targetElement = document.querySelector(selector);
      if (!sourceElement || !targetElement) return;
      targetElement.innerHTML = sourceElement.innerHTML;
    });

    const mobileFiltersForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileFiltersForm) {
      const menuDrawer = mobileFiltersForm.closest('menu-drawer');
      if (menuDrawer) menuDrawer.bindEvents();
    }
    initHorizontalCustomSort();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    const targetFilterHeader = target.querySelector('.facets__filter-header');
    const sourceFilterHeader = source.querySelector('.facets__filter-header');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }

    if (targetFilterHeader && sourceFilterHeader) {
      target.querySelector('.facets__filter-header').outerHTML = source.querySelector('.facets__filter-header').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return [];

    return [
      {
        section: productGrid.dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const params = new URLSearchParams();
    const seen = new Set();

    for (const [key, value] of formData.entries()) {
      const entryKey = `${key}=${value}`;
      if (seen.has(entryKey)) continue;

      seen.add(entryKey);
      params.append(key, value);
    }

    return params.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    FacetFiltersForm.syncMirroredInputs(event.target);
    FacetFiltersForm.snapshotDrawerState(event.target);
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const isMobileCheckbox = Boolean(event.target && event.target.classList && event.target.classList.contains('mobile-facets__checkbox'));
    if (isMobileCheckbox) {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const parentForm = event.target.closest('form');
      const isMobile = Boolean(parentForm && parentForm.id === 'FacetFiltersFormMobile');

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    FacetFiltersForm.snapshotDrawerState();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    if (!url) {
      FacetFiltersForm.openGroupKeys = null;
      FacetFiltersForm.lastMirrorKey = null;
    }
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.drawerOpen = false;
FacetFiltersForm.openGroupKeys = null;
FacetFiltersForm.lastMirrorKey = null;
FacetFiltersForm.lastTriggerSelector = null;
FacetFiltersForm.outsideClickBound = false;
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

function getFilterDrawerElement() {
  return document.querySelector('[data-filter-drawer]');
}

function getFilterDrawerTrigger(slot) {
  const triggers = document.querySelectorAll('[data-filter-drawer-trigger]');
  if (!slot) return triggers[0] || null;

  return Array.from(triggers).find((trigger) => trigger.dataset.filterDrawerTriggerSlot === slot) || null;
}

function updateFilterDrawerTriggers(isOpen) {
  document.querySelectorAll('[data-filter-drawer-trigger]').forEach((trigger) => {
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
}

function isFilterDrawerOpen() {
  const drawer = getFilterDrawerElement();
  return Boolean(drawer && drawer.classList.contains('is-open') && !drawer.hasAttribute('hidden'));
}

function getOpenFilterDrawerGroupKeys() {
  const drawer = getFilterDrawerElement();
  if (!drawer) return null;

  const groups = drawer.querySelectorAll('[data-filter-group-key]');
  if (!groups.length) return null;

  return Array.from(groups)
    .filter((group) => group.open)
    .map((group) => group.dataset.filterGroupKey);
}

function setFilterDrawerOpen(isOpen, options = {}) {
  const drawer = getFilterDrawerElement();
  const { trigger = null, restoreFocus = false, focusCheckedInput = false } = options;

  if (trigger) {
    FacetFiltersForm.lastTriggerSelector = trigger.dataset.filterDrawerTriggerSlot || null;
  }

  if (!drawer) {
    document.body.classList.remove('filter-drawer-open');
    updateFilterDrawerTriggers(false);
    FacetFiltersForm.drawerOpen = false;
    return;
  }

  if (isOpen) {
    drawer.removeAttribute('hidden');
    drawer.classList.add('is-open');
    document.body.classList.add('filter-drawer-open');
  } else {
    drawer.setAttribute('hidden', '');
    drawer.classList.remove('is-open');
    document.body.classList.remove('filter-drawer-open');
  }

  updateFilterDrawerTriggers(isOpen);
  FacetFiltersForm.drawerOpen = isOpen;

  if (isOpen && focusCheckedInput) {
    const focusTarget = drawer.querySelector('[data-filter-popup-checkbox]:checked, [data-filter-popup-checkbox]');
    if (focusTarget) focusTarget.focus();
  }

  if (!isOpen && restoreFocus) {
    const triggerToFocus = getFilterDrawerTrigger(FacetFiltersForm.lastTriggerSelector);
    if (triggerToFocus) triggerToFocus.focus();
  }
}

function bindFilterDrawerEvents() {
  if (bindFilterDrawerEvents.isBound) return;
  bindFilterDrawerEvents.isBound = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-filter-drawer-trigger]');
    if (trigger) {
      event.preventDefault();
      if (isFilterDrawerOpen()) {
        setFilterDrawerOpen(false, { restoreFocus: true });
      } else {
        setFilterDrawerOpen(true, { trigger, focusCheckedInput: true });
      }
      return;
    }

    const closeTrigger = event.target.closest('[data-filter-drawer-close]');
    if (closeTrigger) {
      event.preventDefault();
      setFilterDrawerOpen(false, { restoreFocus: true });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !isFilterDrawerOpen()) return;

    event.preventDefault();
    setFilterDrawerOpen(false, { restoreFocus: true });
  });

  document.addEventListener('toggle', (event) => {
    if (!event.target.matches('[data-filter-group-key]')) return;

    const drawer = getFilterDrawerElement();
    if (!drawer || !drawer.contains(event.target)) return;

    FacetFiltersForm.openGroupKeys = getOpenFilterDrawerGroupKeys() || [];
  }, true);
}

bindFilterDrawerEvents.isBound = false;

function initHorizontalCustomSort() {
  document.querySelectorAll('[data-custom-sort]').forEach((wrapper) => {
    if (wrapper.dataset.customSortBound === 'true') return;

    const sortWrap = wrapper.closest('.facets__sort-select-wrap');
    const select = sortWrap ? sortWrap.querySelector('.facets__sort-select-native') : null;
    const trigger = wrapper.querySelector('[data-custom-sort-trigger]');
    const dropdown = wrapper.querySelector('[data-custom-sort-dropdown]');
    const valueEl = wrapper.querySelector('[data-custom-sort-value]');
    const options = wrapper.querySelectorAll('[data-custom-sort-option]');
    if (!select || !trigger || !dropdown || !valueEl || !options.length) return;

    wrapper.dataset.customSortBound = 'true';
    sortWrap.classList.add('custom-sort-active');

    const closeOnOutside = (e) => {
      if (wrapper.contains(e.target)) return;
      close();
      document.removeEventListener('click', closeOnOutside);
    };
    const open = () => {
      dropdown.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      wrapper.classList.add('is-open');
      requestAnimationFrame(() => document.addEventListener('click', closeOnOutside));
      const selected = dropdown.querySelector('[aria-selected="true"]');
      if (selected) selected.focus();
    };
    const close = () => {
      dropdown.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      wrapper.classList.remove('is-open');
      document.removeEventListener('click', closeOnOutside);
      trigger.focus();
    };
    const setValue = (value, label) => {
      select.value = value;
      valueEl.textContent = label;
      options.forEach((opt) => opt.setAttribute('aria-selected', opt.dataset.value === value ? 'true' : 'false'));
      select.dispatchEvent(new Event('input', { bubbles: true }));
    };

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (dropdown.hidden) open();
      else close();
    });
    options.forEach((opt) => {
      opt.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        setValue(opt.dataset.value, opt.textContent.trim());
        close();
      });
    });
    dropdown.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
      }
    });
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (dropdown.hidden) open();
        else close();
      }
      if (e.key === 'ArrowDown' && dropdown.hidden) {
        e.preventDefault();
        open();
      }
    });

  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initHorizontalCustomSort();
    bindFilterDrawerEvents();
  });
} else {
  initHorizontalCustomSort();
  bindFilterDrawerEvents();
}

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
    this.controlSlider();
    this.controlInput();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    // if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    // if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  fillSlider () {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    inputRangeWrappers.forEach(inputWrapper => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];

      const range = inputRangeTo.max - inputRangeTo.min;
      const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
      const toCurrent = inputRangeTo.value - inputRangeTo.min;
      const minRange = fromCurrent / range * 100;
      const maxRange = toCurrent / range * 100;

      inputWrapper.setAttribute(
        'style',
        `--range-min: ${minRange}%; --range-max: ${maxRange}%`
      );
    })
  }

  controlSlider () {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

    inputRangeWrappers.forEach((inputWrapper, index) => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];
      const inputNumberFrom = inputNumberWrappers[index].querySelectorAll('.field__input')[0];
      const inputNumberTo = inputNumberWrappers[index].querySelectorAll('.field__input')[1];

      inputRangeFrom.oninput = () => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        }
        else {
          inputNumberFrom.value = from;
        }

        this.fillSlider();
      }

      if (Number(inputRangeTo.value) <= 0 ) {
        inputRangeTo.style.zIndex = 2;
      } else {
        inputRangeTo.style.zIndex = 0;
      }

      inputRangeTo.oninput = () => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        }
        else {
          inputNumberTo.value = from;
          inputRangeTo.value = from;
        }

        if (Number(inputRangeTo.value) <= 0 ) {
          inputRangeTo.style.zIndex = 2;
        } else {
          inputRangeTo.style.zIndex = 0;
        }

        this.fillSlider();
      }
    })
  }

  controlInput() {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

    inputNumberWrappers.forEach((inputWrapper, index) => {
      const inputsNumber = inputWrapper.querySelectorAll('.field__input');
      const inputNumberFrom = inputsNumber[0];
      const inputNumberTo = inputsNumber[1];
      const inputRangeFrom = inputRangeWrappers[index].querySelectorAll('.field__range')[0];
      const inputRangeTo = inputRangeWrappers[index].querySelectorAll('.field__range')[1];

      inputNumberFrom.oninput = () => {
        const from = parseInt(inputNumberFrom.value, 10);
        const to = parseInt(inputNumberTo.value, 10);
        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        } 
        else {
          inputRangeFrom.value = from;
        }

        this.fillSlider();
      }

      inputNumberTo.oninput = () => {
        const from = parseInt(inputNumberFrom.value, 10);
        const to = parseInt(inputNumberTo.value, 10);
        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        }
        else {
          inputNumberTo.value = from;
        }

        this.fillSlider();
      }

    })
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
